<template>
    <div style="margin-top: -10px; "> 
        <div class="row">
            <div class="col-8">
                <div class="text-left section-title" style="padding: 5px;">
                    <span class="row-table-font-margins" style="font-family: inherit; font-weight: 600 ; line-height: 1; text-align:center">{{buildingName}} / {{expense.name}}</span>
                </div>
            </div>
            <div class="col-4 add-button-section">
                <div class="text-right" style="padding: 5px;">
                    <!--<span style="margin-right:5px">Add New Unit</span>
                    <router-link class="btn btn-table" :to="{
              name: 'property',
              params: { buildingId: buildingId, buildingName: buildingName },
            }"><i class="fas fa-plus"></i></router-link>-->
                    <span style="
width: 30px;
height: 30px;
border-radius: 5px;
            background-color: #007DFC;
            color: white;
            display: inline-block;
            padding-left: 5px;
            padding-right: 5px;
            text-align: center;
            margin-right:8px;
          ">
                        <i class="fa fa-sliders-h" style="margin-top:7px;transform: rotate(-90deg);" aria-hidden="true"></i>
                    </span>

                    <span @click="showSearch()"
                          style="
                          width: 30px;
                          height: 30px;
                          border-radius: 5px;
                          background-color: #007DFC;
                          color: white;
                          display: inline-block;
                          padding-left: 5px;
                          padding-right: 5px;
                          text-align: center;
                          cursor:pointer;

                          ">
                        <i class="fa fa-search" style="margin-top:7px;" aria-hidden="true"></i>
                    </span>
                    <input type="text" v-if="visibleSearch" class="form-control" name="searchText" id="searchText" style=" display: inline-block; width: 250px; height: 30px;" v-model="filter">
                    <userMenu />
                </div>
            </div>
        </div>

        <div v-if="false" class="row" style="margin-left:1px;">
            <div class="search col-lg-3 col-md-3 col-sm-4 col-6" style="width:180px; margin-bottom:12px">
                <span class="fa fa-search"></span>
                <input type="text" class="form-control" name="searchText" id="searchText" placeholder="Search Expense..." v-model="filter">
            </div>
        </div>
            
        <div class="table-responsive">
            <table class="table table-condensed">
                <thead>
                    <tr>
                        <th scope="col">No</th>

                        <th scope="col">Invoice No</th>
                        <th scope="col">Date</th>
                        <th scope="col">Amount</th>
                        <th scope="col">Credit Note</th>
                        <th scope="col"></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="expense, key in expenses" class="clickable-row">
                        <td scope="row" class="clickable-column"><a @click.prevent="editItem(expense)">{{ ++key }}</a></td>

                        <td class="clickable-column"><a @click.prevent="editItem(expense)">{{ expense.invoiceNo}}</a></td>
                        <td class="clickable-column"><a @click.prevent="editItem(expense)">{{ customFormatter(expense.dueDate)}}</a></td>
                        <td class="clickable-column"><a @click.prevent="editItem(expense)">{{ $filters.currency(expense.amount, '€') }}</a></td>
                        <td class="clickable-column"><a @click.prevent="editItem(expense)">{{ $filters.currency(expense.creditNoteAmount, '€') }}</a></td>

                        <td>
                            <router-link style="display: inline-block; margin-left: 6px; width: 70px;" class="btn btn-table" :to="{
  name: 'credit-notes-expenses',
  params: {
    expenseId: expense.id,
   
    buildingId: buildingId,
                                  monthly:1,
                                 
    buildingName: buildingName,
  

  },
}">Credit Note</router-link>
                        </td>
                    </tr>
                    <tr style="color: black; font-size: 1.11em">
                        <td scope="row"></td>
                        <td></td>
                        <td></td>
                        <td class="text-right">
                            <strong>Total Due :</strong>	                    
                        </td>
                        <td class="text-left">
                            <strong>{{ $filters.currency(totalAmount, '€') }} </strong>
                        </td>
                        
                        <td></td>    
                    </tr>
                </tbody>
            </table>
        </div>
        <!-- MODAL IS HERE -->
        <modal  :scrollable="true" name="deleteAlert" @before-open="beforeOpen" height="auto" :minHeight="150" width="400">
            <div class=""  role="document">
                <div class="">
                    <!-- Modal content-->
                        <deleteAlert v-on:close="modalClosed" :entity-id="selectedItemId" request="additionalExpenses" entity="expense" />
                </div>
            </div>
        </modal>
    </div>
</template>
<script>
import { format, parseISO } from "date-fns";
    
    import { mapState, mapActions } from "vuex";
//import moment from 'moment'
export default {
  data: function () {
    return {
      filter: "",
      expenses: [],
        buildingId: 0,
        expenseName: "",
      expenseId:0,
      //buildingName: "",
      selectedItemId: 0,
      visibleSearch: false,
    };
  },
  mounted() {
      this.buildingId = this.$route.params.buildingId;
      this.expenseName = this.$route.params.expenseName;
      this.expenseId = this.$route.params.expenseId;
   // this.buildingName = this.$route.params.buildingName;
      //this.buildingName = this.$route.params.buildingName;
      this.fetchExpenseOfBuilding(this.expenseId);
      console.log(this.expense)
    this.fetchStatement();
  },
  computed: {
      ...mapState({
          expense: (state) => state.building.currentExpense,
      building: (state) => state.building.currentBuilding,
      buildings: (state) => state.building.buildings,
      numberOfAllowedBuildings: (state) =>
        state.building.numberOfAllowedBuildings,
    }),
    buildingName(){
      if(this.building != null)
        return  this.building.name;
      return ""
    },
    /*getAdditionalExpenses() {
        var committees = this.expenses.filter((supplier) => {
        return supplier.expenseType.name
          .toLowerCase()
          .includes(this.filter.toLowerCase());
      });

      return committees;
    },*/
    totalAmount: function () {
      let sum = 0;
      return this.expenses.reduce(
        (sum, expense) => sum + expense.amount,
        0
      );
    },
  },
        methods: {
            ...mapActions("building", ["fetchExpenseOfBuilding"]),
          
    showSearch() {
      this.visibleSearch = !this.visibleSearch;
    },
    fetchStatement: function () {
      this.mute = true;
        //this.buildingId = 3;
        console.log("The expense " + this.expenseId)
        console.log(this.expense)
        if (this.expense.id == null)
            var request = "/expenses/expenseType?id=" + this.expenseId;
        else
        var request = "/expenses/expenseType?id=" + this.expense.id;
      this.$http
        .get(request, {
          id: this.buildingId,
        })
        .then(({ data }) => {
          this.mute = false;
          //this.contacts = data.contacts;
            this.expenses = data;
        });
    },
    editItem: function (item) {
      this.$router.push({
        name: "additionaldetail",
        params: {
          expenseId: item.id,
          buildingId: this.buildingId,
          buildingName: this.buildingName,
        },
      });
    },
    modalClosed: function (itemDeleted) {
      if (itemDeleted) this.fetchStatement();
    },
    deleteItem: function destroy(item) {
      this.selectedItemId = item.id;
      this.deleteAlert();
    },
    deleteAlert: function () {
      this.$modal.show("deleteAlert");
    },
    // showAddAdditionalExpenses{

    // },
    customFormatter(date) {
      return format(parseISO(date), "dd/MM/yyyy");
    },
  },
};
</script>